export default __webpack_public_path__ + "static/media/K-Jokast-2025-l.6fc2e9c7.png";